import React from "react"
import * as styles from "./index.module.less"

export const FaqTitle = ({ data }) => {
  return (
    <div className="container overflow-hidden">
      <h2 className={"text-left"}>{data.sectionTitle}</h2>
    </div>
  )
}

export const FaqItem = ({ data, active, setActive = () => null, id = "" }) => {
  const { question, answer } = data || {}

  return (
    <div className="container overflow-hidden">
      <ul className={styles.faq}>
        <li>
          <h5
            role={"presentation"}
            onClick={(e) => setActive(id === active ? "" : id)}
          >
            {question}
            <img
              src={require("./more.svg").default}
              alt="Open/Close"
              className={active === id ? styles.active_faq : ""}
              role={"presentation"}
              onClick={(e) => setActive(id === active ? "" : id)}
            />
          </h5>
          {active === id && (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          )}
        </li>
      </ul>
    </div>
  )
}
